import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/63_card_back_winter_dog/63_card_back_winter_dog"
 * Contains 1 texture(s)
 */
export class CardsBacks63CardBackWinterDogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/63_card_back_winter_dog/63_card_back_winter_dog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '63_winter_dog.png'
    ] as const;
}
